import React from 'react';
import ImageUpload from '../ui/ImageUpload';
import Input from '../ui/Input';
import Textarea from '../ui/Textarea';
import PhonePreview from '../campaigns/PhonePreview';
import TokenChips, { appendToken } from './TokenChips';
import styles from './MessagingFields.module.css';

// Matches pickmywork-android's real redirection_screen values — read directly
// from notification.data.redirection_screen when a push is tapped (App.js's
// notifee PRESS listeners) and dispatched in src/components/global/helperFun/
// redirection.js. Not exhaustive of every string that file happens to check
// (a few one-off screens are only ever set from other flows), just the ones
// meaningful to pick when composing a message — free text still works for
// anything else since Android doesn't validate this against a fixed enum.
export const REDIRECTION_TYPES = [
  'JOB', 'JOB_CATEGORY', 'HOME', 'WALLET_TRANSACTION', 'TASK_REPORT',
   'REFERRAL', 'HOME_LEADERBOARD',
   'TRAINING', 'MY_TEAM', 'RECHARGE',
  'RECHARGE_HISTORY', 'HELP', 'OFFERS', 'LEAD_RECOMMENDATION',
  'VIDEO',
];

// Push and in-app share this composer — both ultimately deliver a title/body
// through pickmywork-android's same notification renderer (see push.provider.js).
class PushFields extends React.Component {
  render() {
    const { title = '', body = '', redirectionType = '', redirectionValue = '', imageUrl = '', onChange, showPreview = true } = this.props;
    return (
      <div className={showPreview ? styles.msgLayout : undefined}>
        <div className={styles.msgFields}>
          <div className={styles.fi}>
            <label className={styles.fiLabel}>Title <span className={styles.req}>*</span></label>
            <Input
              placeholder="e.g. 🛒 Your cart misses you!"
              maxLength={65}
              value={title}
              onChange={e => onChange('title', e.target.value)}
            />
            <div className={styles.fiRow}>
              <span className={styles.fiHint}>Under 50 chars ideal for Android lock screen</span>
              <span className={styles.fiCount}>{title.length} / 65</span>
            </div>
            <TokenChips onInsert={token => onChange('title', appendToken(title, token))} />
          </div>
          <div className={styles.fi}>
            <label className={styles.fiLabel}>Body <span className={styles.req}>*</span></label>
            <Textarea
              placeholder="e.g. Complete your purchase and save 10%. Offer expires tonight!"
              maxLength={200}
              rows={3}
              resize={false}
              value={body}
              onChange={e => onChange('body', e.target.value)}
            />
            <div className={styles.fiRow}>
              <span className={styles.fiHint}>2 lines shown on lock screen</span>
              <span className={styles.fiCount}>{body.length} / 200</span>
            </div>
            <TokenChips onInsert={token => onChange('body', appendToken(body, token))} />
          </div>
          <div className={styles.fi}>
            {/* image reaches the device via FCM's data payload (push.provider.js)
                and pickmywork-android's notification.js already reads/renders
                it as the notification's largeIcon/bigImage. */}
            <ImageUpload label={<>Image <span className={styles.opt}>(optional)</span></>} value={imageUrl} onChange={url => onChange('imageUrl', url)} />
          </div>
          <div className={styles.fiDivider} />
          <div className={styles.fi2col}>
            <div className={styles.fi}>
              <label className={styles.fiLabel}>Redirection type <span className={styles.opt}>(optional)</span></label>
              <Input
                list="redirection-type-options"
                placeholder="e.g. JOB, HOME, web…"
                value={redirectionType}
                onChange={e => onChange('redirectionType', e.target.value)}
              />
              <datalist id="redirection-type-options">
                {REDIRECTION_TYPES.map((t) => <option key={t} value={t} />)}
              </datalist>
              <div className={styles.fiHint}>Matches pickmywork-android's redirection_screen values.</div>
            </div>
            <div className={styles.fi}>
              <label className={styles.fiLabel}>Redirection value <span className={styles.opt}>(optional)</span></label>
              <Input
                placeholder="e.g. a job id, url, video id…"
                value={redirectionValue}
                onChange={e => onChange('redirectionValue', e.target.value)}
              />
            </div>
          </div>
        </div>
        {showPreview && <PhonePreview title={title} body={body} />}
      </div>
    );
  }
}

export default PushFields;
